import { webapi } from '@/api/webapi.ts';
import { cancelFlexiForwardRfs } from '@/store/flexi-forward/api/cancelFlexiForwardRfs.ts';
import { executeFlexiForwardTrade } from '@/store/flexi-forward/api/executeFlexiForwardTrade.ts';
import { requestFlexiForwardRfs } from '@/store/flexi-forward/api/requestFlexiForwardRfs.ts';
import { checkFlexiForward } from '@/store/flexi-forward/api/trade-capture/checkFlexiForward.ts';
import { updateFlexiForwardRfs } from '@/store/flexi-forward/api/updateFlexiForwardRfs.ts';

export const flexiForwardApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkFlexiForwardByTradeCapture: checkFlexiForward(builder),
    requestFlexiForwardRfs: requestFlexiForwardRfs(builder),
    updateFlexiForwardRfs: updateFlexiForwardRfs(builder),
    cancelFlexiForwardRfs: cancelFlexiForwardRfs(builder),
    executeFlexiForwardTrade: executeFlexiForwardTrade(builder),
  }),
});

export const { useCheckFlexiForwardByTradeCaptureMutation, useCancelFlexiForwardRfsMutation } = flexiForwardApi;

// CHECK TRADE CAPTURE
export const {
  initiate: initiateCheckFlexiForwardByTradeCapture,
  matchFulfilled: checkFlexiForwardByTradeCaptureMatchFulfilled,
  matchRejected: checkFlexiForwardByTradeCaptureMatchRejected,
} = flexiForwardApi.endpoints.checkFlexiForwardByTradeCapture;

// REQUEST RFS
export const {
  initiate: flexiForwardRequestRfsInitiate,
  matchPending: flexiForwardRequestRfsMatchPending,
  matchFulfilled: flexiForwardRequestRfsMatchFulfilled,
} = flexiForwardApi.endpoints.requestFlexiForwardRfs;

// UPDATE RFS
export const { initiate: flexiForwardUpdateRfsInitiate } = flexiForwardApi.endpoints.updateFlexiForwardRfs;

// CANCEL RFS
export const { initiate: flexiForwardCancelRfsInitiate, matchPending: cancelFlexiForwardRfsMatchPending } =
  flexiForwardApi.endpoints.cancelFlexiForwardRfs;

// EXECUTE TRADE
export const { initiate: flexiForwardExecuteTradeInitiate, matchPending: flexiForwardExecuteTradeMatchPending } =
  flexiForwardApi.endpoints.executeFlexiForwardTrade;
